import InstitutionalInformationDataStore from '../../datastores/InstitutionalInformationDataStore';

export default class InstitutionalInformationDataStoreGraphQL
  implements InstitutionalInformationDataStore
{
  getInstitutionalInformation() {
    const data = {
      institutionalInformation: {
        institutionalInformationStudent: [
          {
            id: 6,
            name: 'Guías y Reglamentos aplicables al Periodo 2024- Ciclo 2 Agosto',
            order: 2,
            deployed: true,
            files: [
              {
                idFile: 1602,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento de Estudios',
                nameFile:
                  'REC - RG005 Reglamento de Estudios de Pregrado3165f6d2-b455-4d36-a189-e8c34ae4ed5a.pdf',
                orderFile: 1
              },
              {
                idFile: 1601,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento de Estudios',
                nameFile:
                  'REC - RG005 Reglamento de Estudios de Pregrado923f9456-876c-4bda-956f-1007c17a718a.pdf',
                orderFile: 1
              },
              {
                idFile: 1600,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento de Estudios',
                nameFile:
                  'REC - RG005 Reglamento de Estudios de Pregrado02cf4a54-6719-40d1-976b-4dd70bb68329.pdf',
                orderFile: 1
              },
              {
                idFile: 1599,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento de Estudios',
                nameFile:
                  'Reglamento de Estudios6d25af56-80b8-4c25-99ad-85997b8a30eb.pdf',
                orderFile: 1
              },
              {
                idFile: 1598,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento de Estudios',
                nameFile:
                  'REC - RG005 Reglamento de Estudios de Pregrado4d45491c-d2bb-45d2-a6f1-dd5cf172bdbb.pdf',
                orderFile: 1
              },
              {
                idFile: 1596,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento de Estudios',
                nameFile:
                  'REC - RG005 Reglamento de Estudios de pregrado_v08_PT021a764d-0c80-4970-a24f-f58930eba106.pdf',
                orderFile: 1
              },
              {
                idFile: 1728,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Resol.Rect. N 0163-2024-R-UTP Reglamento Estudios',
                nameFile:
                  'RR N 0163-2024-R-UTP Aprobacion del Reglamento de Estudios de Pregrado73388ca2-fd7e-40a6-bf9e-ea0502fe16aa.pdf',
                orderFile: 2
              },
              {
                idFile: 1725,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Resol.Rect. N 0163-2024-R-UTP Reglamento Estudios',
                nameFile:
                  'RR N 0163-2024-R-UTP Aprobacion del Reglamento de Estudios de Pregrado33af8a5a-bfdf-4b75-add7-d68e8690c7d6.pdf',
                orderFile: 2
              },
              {
                idFile: 1726,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Resol.Rect. N 0163-2024-R-UTP Reglamento Estudios',
                nameFile:
                  'RR N 0163-2024-R-UTP Aprobacion del Reglamento de Estudios de Pregrado3d5db4c1-b37f-43d7-bc3a-bb9603f914bb.pdf',
                orderFile: 2
              },
              {
                idFile: 1723,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Resol.Rect. N 0164-2022-R-UTP Reglamento Estudios',
                nameFile:
                  'RR.Nº 0164-2022-R-UTP Reglamento de Estudios Pregrado7e0a9aa3-51e9-41d7-bbf3-36bbef98a03f.pdf',
                orderFile: 2
              },
              {
                idFile: 1727,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Resolución. Rect. N 0149-2022-R-UTP Reglamento de ',
                nameFile:
                  'Resolución. Rect. N 0149-2022-R-UTP Reglamento de Estudios4797e03f-51ea-4e66-8e60-628b07d70475.pdf',
                orderFile: 2
              },
              {
                idFile: 1729,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Resolución. Rect. N 0163-2024-R-UTP Reglamento de ',
                nameFile:
                  'RR N 0163-2024-R-UTP Aprobacion del Reglamento de Estudios de Pregrado289ff021-210e-4941-8cbd-71d49848a8cc.pdf',
                orderFile: 2
              },
              {
                idFile: 1841,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Guía del Estudiante 2023 - Ciclo 2 Agosto',
                nameFile:
                  'DPA - GU0344 Guía del Estudiante Lima Sur Pregrado Marzo 2023cac2d372-1d05-4636-a887-b13dc5259141.pdf',
                orderFile: 3
              },
              {
                idFile: 1840,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Guía del Estudiante 2024 - Ciclo 2 Agosto',
                nameFile:
                  'DPA-GU0466-Guia-del-Estudiante-Lima-Sur-Pregrado-Agosto-2024bd5e92dc-22b5-4f22-b3a7-08444d7965d8.pdf',
                orderFile: 3
              },
              {
                idFile: 1842,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Guía del Estudiante 2024 - Ciclo 2 Agosto',
                nameFile:
                  'DPA-GU0489-Guia-del-Estudiante-Lima-Sur-80-20-50-50-Agosto-2024bfdbd8f5-1c47-4511-bcd7-b45be58e0a92.pdf',
                orderFile: 3
              },
              {
                idFile: 1843,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Guía del Estudiante 2024 - Ciclo 2 Agosto',
                nameFile:
                  'DPA-GU0489-Guia-del-Estudiante-Lima-Sur-80-20-50-50-Agosto-2024c1caa346-6a83-4975-977c-6029e6b57caf.pdf',
                orderFile: 3
              },
              {
                idFile: 1904,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'RR Nº0008-2024-R-UTP Reglamento de Becas de Pregra',
                nameFile:
                  'RR Nº 0008-2024-R-UTP Reglamento de Becas de Pregrado marzo 248cf8a3d0-3d42-4802-99c6-99390346a3fb.pdf',
                orderFile: 4
              },
              {
                idFile: 1902,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'RR Nº0008-2024-R-UTP Reglamento de Becas de Pregrado',
                nameFile:
                  'RR Nº 0008-2024-R-UTP Reglamento de Becas de Pregrado marzo 24023e20f6-06e0-47c8-81da-e3d3d29b059f.pdf',
                orderFile: 4
              },
              {
                idFile: 1903,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'RR Nº0008-2024-R-UTP Reglamento de Becas de Pregrado',
                nameFile:
                  'RR Nº 0008-2024-R-UTP Reglamento de Becas de Pregrado marzo 24d748a484-68f2-420d-bd8e-3cb384d5766a.pdf',
                orderFile: 4
              },
              {
                idFile: 1999,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento de Becas',
                nameFile:
                  'Reglamento de Becas - marzo 245a6cc212-23db-423d-b6ed-59aad5dc5f6e.pdf',
                orderFile: 5
              },
              {
                idFile: 2000,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento de Becas',
                nameFile:
                  'Reglamento de Becas - marzo 245a6cc212-23db-423d-b6ed-59aad5dc5f6e.pdf',
                orderFile: 5
              },
              {
                idFile: 2001,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento de Becas',
                nameFile:
                  'Reglamento de Becas - marzo 24fe884b40-dbc6-4eb0-90fc-f046b74849c8.pdf',
                orderFile: 5
              },
              {
                idFile: 2002,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento de Becas',
                nameFile:
                  'Reglamento de Becas - marzo 24ea6a0cf0-106c-4cb6-9005-94e81e8feba5.pdf',
                orderFile: 5
              },
              {
                idFile: 2003,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento de Becas',
                nameFile:
                  'Reglamento de Becas - marzo 240fda79db-4868-478e-ae20-3f949331d1e5.pdf',
                orderFile: 5
              },
              {
                idFile: 2107,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'RR.Nº 0036-2022-R-UTP Protocolo de Bioseguridad',
                nameFile:
                  'RR.Nº 0036-2022-R-UTP Protocolo de Bioseguridadbc20da7b-3287-4bf9-98aa-971b5e700327.pdf',
                orderFile: 6
              },
              {
                idFile: 2103,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'RR.Nº 0036-2022-R-UTP Protocolo de Bioseguridad',
                nameFile:
                  'RR.Nº 0036-2022-R-UTP Protocolo de Bioseguridadbc20da7b-3287-4bf9-98aa-971b5e700327.pdf',
                orderFile: 6
              },
              {
                idFile: 2104,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'RR.Nº 0036-2022-R-UTP Protocolo de Bioseguridad',
                nameFile:
                  'RR.Nº 0036-2022-R-UTP Protocolo de Bioseguridadc0620e95-ccb5-4db1-b568-1f8a13f59140.pdf',
                orderFile: 6
              },
              {
                idFile: 2106,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'RR.Nº 0036-2022-R-UTP Protocolo de Bioseguridad Covid',
                nameFile:
                  'RR.Nº 0036-2022-R-UTP Protocolo de Bioseguridad Covidc0232c30-2b7b-420b-98e1-ae9a70b4c12d.pdf',
                orderFile: 6
              },
              {
                idFile: 2105,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'RR.Nº 0036-2022-R-UTP Protocolo de Bioseguridad Covid',
                nameFile:
                  'RR.Nº 0036-2022-R-UTP Protocolo de Bioseguridad Covidbece2e25-fe94-4bc3-9804-16cd1ab4bb1d.pdf',
                orderFile: 6
              },
              {
                idFile: 2220,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Guia de Becas y Convenios',
                nameFile:
                  'Guia de Convenio y Becas.44f5b003-d1dd-45da-a299-4eb1811ef0c8.pdf',
                orderFile: 7
              },
              {
                idFile: 2221,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Guia de Becas y Convenios',
                nameFile:
                  'Guia de Convenio y Becas.188270d7-957e-4729-ac14-1014ff0473f0.pdf',
                orderFile: 7
              },
              {
                idFile: 2223,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Guia de Becas y Convenios',
                nameFile:
                  'Guia de Convenio y Becas.1c1c6f2f-2859-4407-8724-7a8dff4b6893.pdf',
                orderFile: 7
              },
              {
                idFile: 2224,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Guia de Becas y Convenios',
                nameFile:
                  'Guia de Convenio y Becas.bf07a5eb-bc20-4cff-a1a0-df54ab956c53.pdf',
                orderFile: 7
              },
              {
                idFile: 2219,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Guia de Becas y Convenios',
                nameFile:
                  'Guia de Convenio y Becas.44f5b003-d1dd-45da-a299-4eb1811ef0c8.pdf',
                orderFile: 7
              },
              {
                idFile: 2222,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento Prevención y Sanción Hostigamiento Sexu',
                nameFile:
                  'Reglamento de prevencion y sancion del Hostigamiento Sexual875a5f50-523b-4787-9337-be8234344613.pdf',
                orderFile: 7
              },
              {
                idFile: 2333,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento de Defensoría Universitaria',
                nameFile:
                  'DEU-REG001 Reglamento de la Oficina de la  Defensoria Universitaria (Portal)89e2ae27-4957-46ee-939a-c18a3073a7a9.pdf',
                orderFile: 8
              },
              {
                idFile: 2334,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento de Defensoría Universitaria',
                nameFile:
                  'Reglamento de Defensoría Universitariab9fb0273-20cd-4af9-b304-cb85a08d0e23.pdf',
                orderFile: 8
              },
              {
                idFile: 2332,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento de Defensoría Universitaria',
                nameFile:
                  'DEU-REG001 Reglamento de la Oficina de la  Defensoria Universitaria (Portal)f4239bf5-39be-4865-9ab9-6e0f999d3ee1.pdf',
                orderFile: 8
              },
              {
                idFile: 2331,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento de Defensoría Universitaria',
                nameFile:
                  'DEU-REG001 Reglamento de la Oficina de la  Defensoria Universitaria (Portal)85695327-c1e9-4758-aa0e-4fd27bb85410.pdf',
                orderFile: 8
              },
              {
                idFile: 2330,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento de Defensoría Universitaria',
                nameFile:
                  'Reglamento de Defensoría Universitariab9fb0273-20cd-4af9-b304-cb85a08d0e23.pdf',
                orderFile: 8
              },
              {
                idFile: 2435,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento de Disciplina',
                nameFile:
                  'Reglamento del Internado del Programa de Psicolog3a99a1c5-230e-43e6-88d6-dd1d93dadaef.pdf',
                orderFile: 9
              },
              {
                idFile: 2438,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento de Disciplina',
                nameFile:
                  'Reglamento_de_Disciplina_del_Estudiante V64c4bc877-fec8-4747-ba76-cc8188fb31b5.pdf',
                orderFile: 9
              },
              {
                idFile: 2434,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento de Disciplina del Estudiante',
                nameFile:
                  'Reglamento de Disciplina del Estudianteb583a600-61ce-4185-9bd4-c5b429d32660.pdf',
                orderFile: 9
              },
              {
                idFile: 2436,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento de Disciplina del Estudiante',
                nameFile:
                  'Reglamento de Disciplina del Estudianteb583a600-61ce-4185-9bd4-c5b429d32660.pdf',
                orderFile: 9
              },
              {
                idFile: 2437,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento de Disciplina del Estudiante',
                nameFile:
                  'Reglamento_de_Disciplina_del_Estudiante V6c46ef836-f5cb-4b62-b576-9b5a4511aa6b.pdf',
                orderFile: 9
              },
              {
                idFile: 2547,
                career: 'PREG',
                campus: 'LIMAS',
                title:
                  'Reglamento de prevencion y sancion del Hostigamiento Sexual',
                nameFile:
                  'Reglamento de prevencion y sancion del Hostigamiento Sexualdf578c2d-8554-42d4-887a-4f851914b347.pdf',
                orderFile: 10
              },
              {
                idFile: 2543,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento Prevencion y Sancion Hostigamiento Sexu',
                nameFile:
                  'Reglamento Prevencion y Sancion Hostigamiento Sexual144e2a61-5734-480e-894f-eb96ff888c81.pdf',
                orderFile: 10
              },
              {
                idFile: 2546,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento Prevencion y Sancion Hostigamiento Sexu',
                nameFile:
                  'Reglamento Prevencion y Sancion Hostigamiento Sexualc07b7d83-76db-4472-b01d-592508e7a0e1.pdf',
                orderFile: 10
              },
              {
                idFile: 2548,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento Prevencion y Sancion Hostigamiento Sexu',
                nameFile:
                  'Reglamento Prevencion y Sancion Hostigamiento Sexual144e2a61-5734-480e-894f-eb96ff888c81.pdf',
                orderFile: 10
              },
              {
                idFile: 2545,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'RR N0110-2022 -R-UTP Aprob. Reglamento Becas',
                nameFile:
                  'Resolucion Rectoral N0110-2022-R-UTP Reglamento de Becas44f6ef1a-c6b1-4886-b9ce-18b068291e4f.pdf',
                orderFile: 10
              },
              {
                idFile: 2674,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Acreditación de idioma extranjero',
                nameFile: 'Acreditación de idioma extranjero478d4276-f5a6-4e2',
                orderFile: 11
              },
              {
                idFile: 2673,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Acreditación de idioma extranjero',
                nameFile:
                  'Acreditación de idioma extranjeroac184108-4644-4e11-bf07-1fa64b85bc9f.pdf',
                orderFile: 11
              },
              {
                idFile: 2672,
                career: 'PREG',
                campus: 'LIMAS',
                title:
                  'Acreditación de idioma extranjero o lengua nativa pregrado',
                nameFile:
                  'Acreditación de idioma extranjero o lengua nativa pregrado1017d475-6296-4e81-ba28-d08a30b6c103.pdf',
                orderFile: 11
              },
              {
                idFile: 2675,
                career: 'PREG',
                campus: 'LIMAS',
                title:
                  'Acreditación de idioma extranjero o lengua nativa pregrado',
                nameFile:
                  'Acreditación de idioma extranjero o lengua nativa pregrado8a3c5668-2712-41e7-a942-7f5ab854458e.pdf',
                orderFile: 11
              },
              {
                idFile: 2669,
                career: 'PREG',
                campus: 'LIMAS',
                title:
                  'Acreditación de idioma extranjero o lengua nativa pregrado',
                nameFile:
                  'Acreditación de idioma extranjero o lengua nativa pregrado1017d475-6296-4e81-ba28-d08a30b6c103.pdf',
                orderFile: 11
              },
              {
                idFile: 2671,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento de Becas',
                nameFile:
                  'REC-RG008 Reglamento de Becas de Pregrado vfbf253e5e-7540-49d0-9dba-8e82198c6403.pdf',
                orderFile: 11
              },
              {
                idFile: 2781,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Aprobación Reglamento Grados y Títulos',
                nameFile:
                  'RR Nº 0167-2022-R-UTP Actualiz. Reglamento de GyT y la Guia del Egresadoae2a5279-40f9-4d6e-aeed-4dc88fdef41d.pdf',
                orderFile: 12
              },
              {
                idFile: 2782,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Aprobación Reglamento Grados y Títulos',
                nameFile:
                  'RR Nº 0167-2022-R-UTP Actualiz. Reglamento de GyT y la Guia del Egresado32a2c273-3a91-4dd9-bf55-c39fddb5aace.pdf',
                orderFile: 12
              },
              {
                idFile: 2783,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Aprobación Reglamento Grados y Títulos',
                nameFile:
                  'Aprobación Reglamento Grados y Títulos7ee68669-f219-4416-8d68-ff0206027c11.pdf',
                orderFile: 12
              },
              {
                idFile: 2784,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Aprobación Reglamento Grados y Títulos',
                nameFile:
                  'RR Nº 0167-2022-R-UTP Actualiz. Reglamento de GyT y la Guia del Egresado020adc54-4665-489b-9c92-655ad807e6a0.pdf',
                orderFile: 12
              },
              {
                idFile: 2785,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Aprobación Reglamento Grados y Títulos',
                nameFile:
                  'Aprobación Reglamento Grados y Títulos7ee68669-f219-4416-8d68-ff0206027c11.pdf',
                orderFile: 12
              },
              {
                idFile: 2903,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento de Grados y Títulos',
                nameFile:
                  'Reglamento de Grados y Titulos7abdade3-a9e9-42f7-ab6d-d8fb43417407.pdf',
                orderFile: 13
              },
              {
                idFile: 2904,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento de Grados y Títulos',
                nameFile:
                  'Reglamento de Grados y Títulos14cf0819-7999-4b48-873a-d0b02dd39de4.pdf',
                orderFile: 13
              },
              {
                idFile: 2905,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento de Grados y Títulos',
                nameFile:
                  'Reglamento de Grados y Titulos2344724d-8c31-41c4-99d0-9c26288db5fa.pdf',
                orderFile: 13
              },
              {
                idFile: 2906,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento de Grados y Títulos',
                nameFile:
                  'Reglamento de Grados y Titulos06cf7b1a-83d8-44d2-9094-5beb39d6e3be.pdf',
                orderFile: 13
              },
              {
                idFile: 2907,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento de Grados y Títulos',
                nameFile:
                  'Reglamento de Grados y Títulos14cf0819-7999-4b48-873a-d0b02dd39de4.pdf',
                orderFile: 13
              },
              {
                idFile: 2902,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Resolución Rectoral Nº 0036-2022-R-UTP',
                nameFile:
                  'RR.Nº 0036-2022-R-UTP Aprueba el Protocolo de Bioseguridad COVID-19 en el regreso a actividades presencialesa1b198cd-f160-4c95-bb03-6a626b7206f3.pdf',
                orderFile: 13
              },
              {
                idFile: 3011,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento del Internado de Psicologia',
                nameFile:
                  'Reglamento del Internado de Psicologia042eae48-5df2-4788-a934-1db0bd623db0.pdf',
                orderFile: 14
              },
              {
                idFile: 3012,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento del Internado de Psicologia',
                nameFile:
                  'Reglamento del Internado del Programa de Psicolog14ab44fb-596d-4766-b4a0-951120702d32.pdf',
                orderFile: 14
              },
              {
                idFile: 3013,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento del Internado de Psicologia',
                nameFile:
                  'Reglamento del Internado del Programa de Psicolog0c505c12-2155-40fb-9111-83b953fda55e.pdf',
                orderFile: 14
              },
              {
                idFile: 3014,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento del Internado de Psicologia',
                nameFile:
                  'Reglamento del Internado del Programa de Psicolog3e1a7f7e-7a9d-4ff4-aa93-521535713234.pdf',
                orderFile: 14
              },
              {
                idFile: 3015,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento del Internado de Psicologia',
                nameFile:
                  'Reglamento del Internado de Psicologia042eae48-5df2-4788-a934-1db0bd623db0.pdf',
                orderFile: 14
              },
              {
                idFile: 3152,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Aprobacion del Reglamento de SECIGRA',
                nameFile:
                  'Aprobacion del Reglamento de SECIGRA165b4295-fec8-4443-9eef-6a40f77a8871.pdf',
                orderFile: 15
              },
              {
                idFile: 3153,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Aprobacion del Reglamento de SECIGRA',
                nameFile:
                  'Aprobacion del Reglamento de SECIGRA34813365-f0cf-4569-8eba-441fd401c5ad.pdf',
                orderFile: 15
              },
              {
                idFile: 3154,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Aprobacion del Reglamento de SECIGRA',
                nameFile:
                  'Aprobacion del Reglamento de SECIGRA61ec30d0-5ff1-4438-8f71-29bffcafee04.pdf',
                orderFile: 15
              },
              {
                idFile: 3155,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Aprobacion del Reglamento de SECIGRA',
                nameFile:
                  'Aprobacion del Reglamento de SECIGRA613d4e8a-4d2b-4db1-a259-0e1710574e9f.pdf',
                orderFile: 15
              },
              {
                idFile: 3156,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Aprobacion del Reglamento de SECIGRA',
                nameFile:
                  'Aprobacion del Reglamento de SECIGRA613d4e8a-4d2b-4db1-a259-0e1710574e9f.pdf',
                orderFile: 15
              },
              {
                idFile: 3148,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Guía de Becas y Convenios',
                nameFile:
                  'Guía de Becas y Convenios UTPa4081fd7-6985-4029-87fe-8991a9d12589.pdf',
                orderFile: 15
              },
              {
                idFile: 3149,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento Defensoria Universitaria',
                nameFile:
                  'Reglamento de la Oficina de la Defensoría Universitariaef3a6dc5-c23f-4027-bb09-d464dd5334b1.pdf',
                orderFile: 15
              },
              {
                idFile: 3266,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Tarifario',
                nameFile: 'Tarifario7f4b1747-30e6-46e3-9edc-21e55181b034.pdf',
                orderFile: 16
              },
              {
                idFile: 3267,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Tarifario',
                nameFile: 'Tarifariod53cdaa5-0787-4dab-8127-a56c20ebb6de.pdf',
                orderFile: 16
              },
              {
                idFile: 3268,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Tarifario',
                nameFile: 'Tarifariof5c9453b-9c73-49ac-a855-1e1d5d45062e.pdf',
                orderFile: 16
              },
              {
                idFile: 3269,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Tarifario',
                nameFile: 'Tarifario5d16a08f-c968-4180-ad3e-c7186c5a38d0.pdf',
                orderFile: 16
              },
              {
                idFile: 3270,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Tarifario',
                nameFile: 'Tarifario7f4b1747-30e6-46e3-9edc-21e55181b034.pdf',
                orderFile: 16
              },
              {
                idFile: 3334,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento de Disciplina del Estudiante',
                nameFile:
                  'REC - RG005 Reglamento de Disciplina_v02e93e5c2e-c828-43a4-87d0-e7b107877269.pdf',
                orderFile: 17
              },
              {
                idFile: 3357,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento Prevención y Sanción Hostigamiento Sexual',
                nameFile:
                  'Reglamento de prevencion y sancion del Hostigamiento Sexual2cb800e4-93e1-425c-a7bb-b31de74ff2e3.pdf',
                orderFile: 18
              },
              {
                idFile: 3378,
                career: 'PREG',
                campus: 'LIMAS',
                title:
                  'Acreditación de idioma extranjero o lengua nativa Pregrado',
                nameFile:
                  'Resolución Rectoral N° 141-2019-R-UTP Acreditación de idioma extranjero o lengua nativa Pregrado2df707d5-161f-4911-a05c-6d42d66e3bdf.pdf',
                orderFile: 19
              },
              {
                idFile: 3400,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Aprobación Reglamento Grados y Títulos',
                nameFile:
                  'Aprobación Reglamento Grados y Títulosad91600b-cbfc-44b0-a476-aa0582588fdf.pdf',
                orderFile: 21
              },
              {
                idFile: 3422,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento de Grados y Títulos',
                nameFile:
                  'Reglamento de Grados y Títulos6e2bc3c2-ba80-4fe2-9e96-d66039a2782f.pdf',
                orderFile: 25
              },
              {
                idFile: 3444,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Reglamento del Internado de Psicologia',
                nameFile:
                  'Reglamento del Internado de Psicologia59636563-8c41-4bd1-b644-93fe4fcf5f96.pdf',
                orderFile: 26
              },
              {
                idFile: 3484,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Aprobacion del Reglamento de SECIGRA',
                nameFile:
                  'Aprobacion del Reglamento de SECIGRA606373c1-8c7e-419b-8aa0-3baf9e3ddf88.pdf',
                orderFile: 27
              },
              {
                idFile: 3483,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Tarifario',
                nameFile: 'Tarifario9a4c6a72-26a2-417e-bf59-c65efff57ec5.pdf',
                orderFile: 27
              },
              {
                idFile: 3527,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Politicas Diversidad Equidad Inclusion Estudiantes',
                nameFile:
                  'Politicas de Diversidad equidad e Inclusioon para estudiantes288b8309-ba70-4903-a6cb-ebadb9d882fc.pdf',
                orderFile: 28
              },
              {
                idFile: 3528,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Politicas Diversidad Equidad Inclusion Estudiantes',
                nameFile:
                  'Politicas de Diversidad equidad e Inclusioon para estudiantesebeb7fc1-fd27-4d66-a44f-94cc1aa1b2b7.pdf',
                orderFile: 28
              },
              {
                idFile: 3529,
                career: 'PREG',
                campus: 'LIMAS',
                title: 'Politicas Diversidad Equidad Inclusion Estudiantes',
                nameFile:
                  'Politicas de Diversidad equidad e Inclusioon para estudiantes2e603cfe-1d7c-48d6-a1ed-e6e7cf9c37b5.pdf',
                orderFile: 28
              }
            ]
          }
        ]
      }
    };
    return data;
  }
}
